import Vue from 'vue'
import Vuex from 'vuex'

import user from "./user"
import shared from "./shared"
import cards from "./cards"
import decks from "./decks"
import collections from "./collections"

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user: user,
        shared: shared,
        cards: cards,
        decks: decks,
        collections: collections,
    }

    // state: {
    //     error: null,
    //
    //     // user auth
    //     user: null,
    //     loading: false,
    //     isUserLoggedIn: false,
    //
    //     // user indicators
    //     loginSnackbar: false,
    //     logoutSnackbar: false,
    //     registrationSnackbar: false,
    //
    //     // cards page
    //     showFilterDrawer: false,
    //
    //     // cards
    //     cardData: [],
    //     dictionaryData: [],
    //     setList: [],
    //     rarityList: [],
    //     alignmentList: [],
    //     classList: [],
    //     typeList: [],
    //     bookList: [],
    //     brigadeList: [],
    //     ntBookList: [],
    //     otBookList: [],
    // },
    // getters: {
    //     cards: state => {
    //         return state.cardData;
    //     },
    //     card: (state, getters) => (cardID) => {
    //         return getters.cardData.find(card => {
    //             return card.id === cardID
    //         })
    //     },
    //     user: state => {
    //         return state.user;
    //     },
    //     error: state => {
    //         return state.error;
    //     },
    //     loading: state => {
    //         return state.loading;
    //     },
    //     isUserLoggedIn: state => {
    //         return state.isUserLoggedIn;
    //     },
    //     getSetList: state => {
    //         return state.setList;
    //     },
    //     getAlignmentList: state => {
    //         return state.alignmentList;
    //     },
    //     getClassList: state => {
    //         return state.classList;
    //     },
    //     getRarityList: state => {
    //         return state.rarityList;
    //     },
    //     getTypeList: state => {
    //         return state.typeList;
    //     },
    //     getBookList: state => {
    //         return state.bookList;
    //     },
    //     getBrigadeList: state => {
    //         return state.brigadeList;
    //     },
    //     getDictionaries: state => {
    //         return state.dictionaryData;
    //     },
    //     getFilteredCards: (state, getters) => (filterValues) => {
    //         // start with all cards in the pot
    //         let returnCards = getters.cards;
    //
    //         // narrow down pool
    //         if (filterValues.name !== "" && filterValues.name !== null) {
    //             returnCards = getters.getCardsByName(filterValues.name, returnCards);
    //         }
    //         if (filterValues.specialAbility !== "" && filterValues.specialAbility !== null) {
    //             returnCards = getters.getCardsBySpecialAbility(filterValues.specialAbility, returnCards);
    //         }
    //         if (filterValues.setList.length > 0) {
    //             returnCards = getters.getCardsBySet(filterValues.setList, returnCards);
    //         }
    //         if (filterValues.identifier !== "" && filterValues.identifier !== null) {
    //             returnCards = getters.getCardsByIdentifier(filterValues.identifier, returnCards);
    //         }
    //         if (filterValues.brigadeList.length > 0) {
    //             returnCards = getters.getCardsByBrigade(filterValues.brigadeList, returnCards);
    //         }
    //         if (filterValues.classList.length > 0) {
    //             returnCards = getters.getCardsByClass(filterValues.classList, returnCards);
    //         }
    //         if (filterValues.typeList.length > 0) {
    //             returnCards = getters.getCardsByType(filterValues.typeList, returnCards);
    //         }
    //         if (filterValues.alignmentList.length > 0) {
    //             returnCards = getters.getCardsByAlignment(filterValues.alignmentList, returnCards);
    //         }
    //         if (filterValues.bookList.length > 0) {
    //             returnCards = getters.getCardsByBook(filterValues.bookList, returnCards);
    //         }
    //         if (filterValues.rarityList.length > 0) {
    //             returnCards = getters.getCardsByRarity(filterValues.rarityList, returnCards);
    //         }
    //
    //         //TODO: remove duplicates here eventually
    //         console.log(returnCards);
    //         return returnCards.sort(sortCards);
    //     },
    //     getCardsBySet: (state) => (setList, cards) => {
    //         let returnList = [];
    //         cards.forEach(card => {
    //             let cardSetName = state.dictionaryData["sets"][card.set].name;
    //             if (state.dictionaryData["sets"][card.set].subset !== undefined) {
    //                 cardSetName = cardSetName + " (" + state.dictionaryData["sets"][card.set].subset + ")";
    //             }
    //             setList.forEach(setName => {
    //                 if (cardSetName === setName) {
    //                     returnList.push(card);
    //                 }
    //             });
    //         });
    //         return returnList;
    //     },
    //     getCardsByRarity: () => (rarityList, cards) => {
    //         let returnList = [];
    //         cards.forEach(card => {
    //             let added = false;
    //             rarityList.forEach(() => {
    //                 if (rarityList.includes(card.rarity) && !added) {
    //                     returnList.push(card);
    //                     added = true;
    //                 }
    //             });
    //         });
    //         console.log(returnList);
    //         return returnList;
    //     },
    //     getCardsByBrigade: () => (brigadeList, cards) => {
    //         let returnList = [];
    //         cards.forEach(card => {
    //             if (card.brigades !== undefined) {
    //                 let cardBrigades = card.brigades;
    //                 if (card.secondSide !== undefined) {
    //                     if (card.secondSide.brigades !== undefined) {
    //                         cardBrigades = cardBrigades.concat(card.secondSide.brigades);
    //                     }
    //                 }
    //                 let hasAll = true;
    //                 brigadeList.forEach(brigade => {
    //                     if (!cardBrigades.includes(brigade)) {
    //                         hasAll = false;
    //                     }
    //                 });
    //                 if (hasAll) {
    //                     returnList.push(card);
    //                 }
    //             }
    //         });
    //         return returnList;
    //     },
    //     getCardsByClass: () => (classList, cards) => {
    //         let returnList = [];
    //         cards.forEach(card => {
    //             if (card.classes !== undefined) {
    //                 let cardClasses = card.classes;
    //                 if (card.secondSide !== undefined) {
    //                     if (card.secondSide.classes !== undefined) {
    //                         cardClasses = cardClasses.concat(card.secondSide.classes);
    //                     }
    //                 }
    //                 let hasAll = true;
    //                 classList.forEach(brigade => {
    //                     if (!cardClasses.includes(brigade)) {
    //                         hasAll = false;
    //                     }
    //                 });
    //                 if (hasAll) {
    //                     returnList.push(card);
    //                 }
    //             }
    //         });
    //         return returnList;
    //     },
    //     getCardsByName: () => (name, cards) => {
    //         return cards.filter(function (card) {
    //             if (card.metadata !== undefined && card.metadata.compositeName !== undefined) {
    //                 return card.metadata.compositeName.toLowerCase().includes(name.toLowerCase());
    //             } else {
    //                 return card.name.toLowerCase().includes(name.toLowerCase())
    //             }
    //         });
    //     },
    //     getCardsBySpecialAbility: () => (specialAbility, cards) => {
    //         return cards.filter(function (card) {
    //             if (card.specialAbility !== undefined) {
    //                 let cardSpecialAbility = card.specialAbility;
    //                 if (card.secondSide !== undefined) {
    //                     if (card.secondSide.specialAbility !== undefined) {
    //                         cardSpecialAbility = cardSpecialAbility.concat(card.secondSide.specialAbility);
    //                     }
    //                 }
    //                 return cardSpecialAbility.toLowerCase().includes(specialAbility.toLowerCase());
    //             }
    //         });
    //     },
    //     getCardsByIdentifier: () => (identifier, cards) => {
    //         let returnList = [];
    //         cards.forEach((card) => {
    //             if (card.identifiers !== undefined) {
    //                 let cardIdentifiers = card.identifiers;
    //                 if (card.secondSide !== undefined) {
    //                     if (card.secondSide.identifiers !== undefined) {
    //                         cardIdentifiers = cardIdentifiers.concat(card.secondSide.identifiers);
    //                     }
    //                 }
    //                 let added = false;
    //                 cardIdentifiers.forEach(cardIdentifier => {
    //                     if (cardIdentifier.toLowerCase().includes(identifier.toLowerCase()) && !added) {
    //                         returnList.push(card);
    //                         added = true;
    //                     }
    //                 });
    //             }
    //         });
    //         return returnList;
    //     },
    //     getCardsByType: () => (typeList, cards) => {
    //         let returnList = [];
    //         cards.forEach((card) => {
    //             let cardTypes = [];
    //             cardTypes.push(card.type);
    //             if (card.secondSide !== undefined) {
    //                 cardTypes.push(card.secondSide.type);
    //             }
    //             let hasAll = true;
    //             typeList.forEach(type => {
    //                 if (!cardTypes.includes(type)) {
    //                     hasAll = false;
    //                 }
    //             });
    //             if (hasAll) {
    //                 returnList.push(card);
    //             }
    //         });
    //         return returnList;
    //     },
    //     getCardsByAlignment: () => (alignmentList, cards) => {
    //         let returnList = [];
    //         cards.forEach((card) => {
    //             let cardAlignments = [];
    //             cardAlignments.push(card.alignment);
    //             if (card.secondSide !== undefined) {
    //                 cardAlignments.push(card.secondSide.alignment);
    //             }
    //             let hasAll = true;
    //             alignmentList.forEach(type => {
    //                 if (!cardAlignments.includes(type)) {
    //                     hasAll = false;
    //                 }
    //             });
    //             if (hasAll) {
    //                 returnList.push(card);
    //             }
    //         });
    //         return returnList;
    //     },
    //     getCardsByBook: () => (bookList, cards) => {
    //         let returnList = [];
    //         cards.forEach((card) => {
    //             if (card.reference !== undefined) {
    //                 let cardBooks = [];
    //                 cardBooks.push(card.reference.book);
    //                 if (card.secondSide !== undefined) {
    //                     if (card.secondSide.reference !== undefined) {
    //                         cardBooks.push(card.secondSide.reference.book);
    //                     }
    //                 }
    //                 let hasAll = true;
    //                 bookList.forEach(type => {
    //                     if (!cardBooks.includes(type)) {
    //                         hasAll = false;
    //                     }
    //                 });
    //                 if (hasAll) {
    //                     returnList.push(card);
    //                 }
    //             }
    //         });
    //         return returnList;
    //     },
    // },
    // mutations: {
    //     setUser(state, payload) {
    //         state.user = payload;
    //     },
    //     setUserLoggedIn(state, payload) {
    //         state.isUserLoggedIn = payload;
    //     },
    //     setLoading(state, payload) {
    //         state.loading = payload;
    //     },
    //     setError(state, payload) {
    //         state.error = payload;
    //     },
    //     clearError(state) {
    //         state.error = null;
    //     },
    //     setLogoutSnackbar(state, payload) {
    //         state.logoutSnackbar = payload;
    //     },
    //     setRegisterSnackbar(state, payload) {
    //         state.registrationSnackbar = payload;
    //     },
    //     setLoginSnackbar(state, payload) {
    //         state.loginSnackbar = payload;
    //     },
    //
    //     SET_CARD_DATA: (state, cards) => state.cardData = cards,
    //
    //     SET_DICTIONARY_DATA: (state, dictionaries) => state.dictionaryData = dictionaries,
    //
    //     SET_SET_LIST_DATA: (state, setList) => state.setList = setList,
    //
    //     SET_ALIGNMENT_LIST_DATA: (state, alignmentList) => state.alignmentList = alignmentList,
    //
    //     SET_BOOK_LIST_DATA: (state, bookList) => state.bookList = bookList,
    //
    //     SET_BRIGADE_LIST_DATA: (state, brigadeList) => state.brigadeList = brigadeList,
    //
    //     SET_CLASS_LIST_DATA: (state, classList) => state.classList = classList,
    //
    //     SET_RARITY_LIST_DATA: (state, rarityList) => state.rarityList = rarityList,
    //
    //     SET_TYPE_LIST_DATA: (state, typeList) => state.typeList = typeList,
    // },
    // actions: {
    //     clearError({commit}) {
    //         commit("clearError");
    //     },
    //     setError({commit}, payload) {
    //         commit("setError", payload);
    //     },
    //
    //     signOutUser({commit}) {
    //         firebase.auth().signOut()
    //             .then(
    //                 () => {
    //                     commit("setLogoutSnackbar", true);
    //                     // Sign-out successful.
    //                 })
    //             .catch(error => {
    //                 console.log(error);
    //             })
    //     },
    //
    //     fetchUserState({commit}, user) {
    //         commit("setUserLoggedIn", user !== null);
    //         if (user) {
    //             commit("setUser", {
    //                 displayName: user.displayName,
    //                 email: user.email,
    //                 uid: user.uid,
    //                 emailVerified: user.emailVerified,
    //             });
    //         } else {
    //             commit("setUserLoggedIn", false);
    //             commit("setUser", null);
    //         }
    //     },
    //
    //     fetchUserData ({commit, getters}) {
    //         commit("setLoading", true);
    //         const docRef = firebase.firestore().collection("users").doc(getters.user.uid);
    //
    //         docRef.get().then(function(doc) {
    //             if (doc.exists) {
    //                 console.log("Document data:", doc.data());
    //             } else {
    //                 // doc.data() will be undefined in this case
    //                 console.log("No such document!");
    //             }
    //             commit("setLoading", false);
    //         }).catch(function(error) {
    //             console.log("Error getting document:", error);
    //         });
    //     },
    //
    //     signUpUser({commit, dispatch}, payload) {
    //         commit("setLoading", true);
    //         commit("clearError");
    //         firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
    //             .then(
    //                 data => {
    //                     commit("setLoading", false);
    //                     commit("setRegisterSnackbar", true);
    //                     const newUser = {
    //                         displayName: payload.username,
    //                         email: data.user.email,
    //                         uid: data.user.uid,
    //                         emailVerified: data.user.emailVerified,
    //                     };
    //                     commit('setUser', newUser);
    //                     firebase.auth().currentUser.updateProfile({
    //                         displayName: payload.username,
    //                     })
    //                         .then(() => {
    //                             let user = firebase.auth().currentUser;
    //                             commit("setUser", {
    //                                 displayName: user.displayName,
    //                                 email: user.email,
    //                                 uid: user.uid,
    //                                 emailVerified: user.emailVerified,
    //                             });
    //                             firebase.firestore().collection("users").doc(user.uid).set({
    //                                 displayName: user.displayName,
    //                                 email: user.email,
    //                                 uid: user.uid,
    //                                 decks: {},
    //                                 collections: {},
    //                             })
    //                                 .then(function () {
    //                                     console.log("Document successfully written!");
    //                                     dispatch("fetchUserData");
    //                                 })
    //                                 .catch(function (error) {
    //                                     console.error("Error: ", error);
    //                                 });
    //
    //                         });
    //                 })
    //             .catch(error => {
    //                 commit("setLoading", false);
    //                 commit("setError", error);
    //                 console.log(error);
    //             })
    //     },
    //     signInUser({commit}, payload) {
    //         commit("setLoading", true);
    //         commit("clearError");
    //         firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
    //             .then(
    //                 data => {
    //                     commit("setLoading", false);
    //                     const newUser = {
    //                         // displayName: data.user.displayName,
    //                         email: data.user.email,
    //                         uid: data.user.uid,
    //                         emailVerified: data.user.emailVerified,
    //                     };
    //                     commit('setUser', newUser);
    //                     commit("setLoginSnackbar", true);
    //                 })
    //             .catch(
    //                 error => {
    //                     commit("setLoading", false);
    //                     commit("setError", error);
    //                     console.log(error);
    //                 });
    //     },
    //
    //     initializeAppData: async context => {
    //         firebase.firestore().collection("dictionaries").get().then((snapshot) => {
    //             const dictionaries = {};
    //
    //             snapshot.forEach(doc => {
    //                 dictionaries[doc.id] = doc.data();
    //             });
    //             console.log("initialized dictionaries");
    //             console.log(dictionaries);
    //             context.commit('SET_DICTIONARY_DATA', dictionaries);
    //
    //             // create set abbreviation list
    //             let setList = [];
    //             Object.keys(context.state.dictionaryData["sets"]).forEach((setID) => {
    //                 let setName = context.state.dictionaryData["sets"][setID].name;
    //                 if (context.state.dictionaryData["sets"][setID].subset !== undefined) {
    //                     setName = setName + " (" + context.state.dictionaryData["sets"][setID].subset + ")"
    //                 }
    //                 setList.push(setName);
    //             });
    //
    //             console.log("initialized set list");
    //             console.log(setList);
    //             context.commit('SET_SET_LIST_DATA', setList);
    //
    //             context.commit('SET_ALIGNMENT_LIST_DATA', context.state.dictionaryData["misc"]["alignmentList"]);
    //
    //             context.commit('SET_BOOK_LIST_DATA', context.state.dictionaryData["misc"]["bookList"]);
    //
    //             context.commit('SET_BRIGADE_LIST_DATA', context.state.dictionaryData["misc"]["brigadeList"]);
    //
    //             context.commit('SET_CLASS_LIST_DATA', context.state.dictionaryData["misc"]["classList"]);
    //
    //             context.commit('SET_RARITY_LIST_DATA', context.state.dictionaryData["misc"]["rarityList"]);
    //
    //             context.commit('SET_TYPE_LIST_DATA', context.state.dictionaryData["misc"]["typeList"]);
    //
    //         });
    //
    //         firebase.firestore().collection("cards").get().then((snapshot) => {
    //             const cards = [];
    //
    //             snapshot.forEach(doc => {
    //                 let docCards = doc.data();
    //                 // combines the set ordered cards into a single list of cards
    //                 Object.keys(docCards).forEach((cardID) => {
    //                     cards.push(docCards[cardID]);
    //                 });
    //             });
    //
    //             // add card metadata
    //
    //             cards.forEach((card) => {
    //                 // initialize metadata object
    //                 card["metadata"] = {};
    //
    //                 // add set data from dictionary
    //                 card["metadata"]["setInfo"] = context.state.dictionaryData["sets"][card["set"]];
    //
    //                 // construct image name
    //                 let name = card["name"];
    //                 if (card["secondSide"] !== undefined) {
    //                     if (card["secondSide"]["name"] !== undefined && card["secondSide"]["name"] !== name) {
    //                         card["metadata"]["compositeName"] = name + " / " + card["secondSide"]["name"];
    //
    //                         name = name + "/" + card["secondSide"]["name"];
    //                     }
    //                 }
    //
    //                 name = name.replace(/:/g, "_").replace(/\?/g, "").replace(/'/g, "").replace(/"/g, "").replace(/\//g, "_").replace(/,/g, "").replace(/ /g, "_");
    //
    //                 // add image link
    //                 card["metadata"]["imageLink"] = context.state.dictionaryData["misc"]["imageBase"] + card["set"] + "_" + card.id + "00" + "_" + name + ".jpg";
    //
    //             });
    //
    //             // finished adding card metadata
    //
    //             console.log("initialized cards");
    //             console.log(cards);
    //             context.commit('SET_CARD_DATA', cards);
    //         });
    //     },
    // },
});
